import { API } from '../config';

export function getNews() {
	return fetch(`${API}/widgets/news`, {
		headers: {},
		mode: 'cors',
	})
		.then(res => res.json())
		.catch(error => error);
}
